import { lazy, Suspense } from "react";
import { Outlet } from "react-router";
import UserAddPage from "../pages/admin/users/add/index";
import UserEditPage from "../pages/admin/users/edit/index";
import UserManagementPage from "../pages/admin/users";
import ComponentFillGenericLoader from "../components/loader/generic.spinner";
import {
  cpdContentCasesState,
  cpdContentCoursesState,
  cpdContentNodesState,
} from "../state";
import PageContextProvider from "../components/layout/page.provider";
import CreateOrUpdateCase from "../pages/cms/cpd/cases/create.scenario";
import { ActionType } from "../pages/cms/cpd/cases/case.details";
import AnalyticsPage from "../pages/analytics";
const MainLayout = lazy(() => import("../components/layout"));
const AddConditionPage = lazy(() => import("../pages/cms/guidelines"));
const NewCoursePage = lazy(() => import("../pages/cms/courses"));
const CpdCourseDetailsPage = lazy(() =>
  import("../pages/cms/cpd/course.details")
);
const DashboardPage = lazy(() => import("../pages/dashboard"));
const CpdQuizPage = lazy(() => import("../pages/cms/cpd/quiz"));
const CpdCasePage = lazy(() => import("../pages/cms/cpd/cases/case.details"));
const CMSContentPage = lazy(() => import("../components/layout/page"));
const CpdConditionDetailsPage = lazy(() =>
  import("../pages/cms/cpd/condition.details")
);
const UserAnalyticsPreviewPage = lazy(() =>
  import("../pages/admin/users/preview")
);

export const privateRoutes = [
  {
    path: "",
    element: (
      <Suspense fallback={<ComponentFillGenericLoader />}>
        <MainLayout>
          <PageContextProvider>
            <Outlet />
          </PageContextProvider>
        </MainLayout>
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: <DashboardPage />,
        children: [],
      },
      { path: "analytics", element: <AnalyticsPage />, children: [] },
      {
        path: "manage/cpd",
        element: <Outlet />,
        children: [
          {
            path: "courses",
            element: (
              <CMSContentPage
                pageToolBarLandingTitle={""}
                pageToolBarLandingLabel={""}
                pageToolBarLandingSubTitle={""}
                pageToolBarDetailsTitle={""}
                pageToolBarDetailsSubTitle={""}
                pageToolBarNewTitle={""}
                pageToolBarNewSubTitle={""}
                defaultStorageStateKey={cpdContentCoursesState}
              >
                <Outlet />
              </CMSContentPage>
            ),
            children: [
              {
                path: ":id/details",
                element: <CpdCourseDetailsPage />,
              },
              {
                path: "add-new-course",
                element: <NewCoursePage />,
              },
            ],
          },
          {
            path: "conditions",
            element: (
              <CMSContentPage
                pageToolBarLandingTitle={""}
                pageToolBarLandingLabel={""}
                pageToolBarLandingSubTitle={""}
                pageToolBarDetailsTitle={""}
                pageToolBarDetailsSubTitle={""}
                pageToolBarNewTitle={""}
                pageToolBarNewSubTitle={""}
                defaultStorageStateKey={cpdContentNodesState}
              >
                <Outlet />
              </CMSContentPage>
            ),
            children: [
              {
                path: ":id/details",
                element: <CpdConditionDetailsPage />,
              },
              {
                path: "add-new-condition",
                element: <AddConditionPage />,
              },
            ],
          },
          {
            path: "nodes",
            element: (
              <CMSContentPage
                pageToolBarLandingTitle={""}
                pageToolBarLandingLabel={""}
                pageToolBarLandingSubTitle={""}
                pageToolBarDetailsTitle={""}
                pageToolBarDetailsSubTitle={""}
                pageToolBarNewTitle={""}
                pageToolBarNewSubTitle={""}
                defaultStorageStateKey={cpdContentNodesState}
              >
                <Outlet />
              </CMSContentPage>
            ),
            children: [
              {
                path: ":id/quizzes-resources",
                element: <CpdQuizPage />,
              },
              {
                path: "add-new-node",
                element: <CpdQuizPage />,
              },
            ],
          },
          {
            path: "cases",
            element: (
              <CMSContentPage
                pageToolBarLandingTitle={""}
                pageToolBarLandingLabel={""}
                pageToolBarLandingSubTitle={""}
                pageToolBarDetailsTitle={""}
                pageToolBarDetailsSubTitle={""}
                pageToolBarNewTitle={""}
                pageToolBarNewSubTitle={""}
                defaultStorageStateKey={cpdContentCasesState}
              >
                <Outlet />
              </CMSContentPage>
            ),
            children: [
              {
                path: ":id/details",
                element: <CpdCasePage />,
              },
              {
                path: "add-new-case",
                element: (
                  <CreateOrUpdateCase formType={ActionType.CREATE_NEW_CASE} />
                ),
              },
            ],
          },
        ],
      },
      {
        path: "manage/auth/users",
        element: <Outlet />,
        children: [
          { path: "", element: <UserManagementPage /> },
          { path: "add-new-user", element: <UserAddPage /> },
          { path: ":uid/edit", element: <UserEditPage /> },
          { path: ":uid/details", element: <UserAnalyticsPreviewPage /> },
        ],
      },
    ],
  },
];
